import React, { useState, useEffect } from "react";
import axios from 'axios';
import BlogListTwo from './BlogListTwo';

const BlogPropTwo = ({ column, StyleVarProp }) => {
    const [allItems, setAllItems] = useState([]);
    const [dataVisibleCount, setDataVisibleCount] = useState(6);
    const [dataIncrement] = useState(3);
    const [noMorePost, setNoMorePost] = useState(false);
    const [visibleItems, setVisibleItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeFilter, setActiveFilter] = useState("all");
    const [categories, setCategories] = useState([]);
    const API_SOURCES = [
        {
            key: "news",
            label: "News",
            fetch: async () => {
                const NEWS_CATEGORY_ID = 9439;
                const resp = await axios.get(`https://whatson.guide/wp-json/wp/v2/posts?categories=${NEWS_CATEGORY_ID}&status=publish&orderby=date&order=desc&_embed&per_page=20&page=1`);
                return resp.data.map(post => {
                    let featuredImage = '';
                    if (post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0]) {
                        featuredImage = post._embedded['wp:featuredmedia'][0].source_url;
                    }
                    let authorName = 'Unknown Author';
                    if (post._embedded && post._embedded.author && post._embedded.author[0]) {
                        authorName = post._embedded.author[0].name;
                    }
                    const formatDate = (dateString) => {
                        const date = new Date(dateString);
                        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                    };
                    return {
                        id: post.id,
                        slug: post.slug,
                        title: post.title?.rendered || '',
                        content: post.content?.rendered || '',
                        excerpt: post.excerpt?.rendered || '',
                        date: formatDate(post.date),
                        link: `/blog/news/${post.slug}`,
                        author: authorName,
                        featured_image: featuredImage,
                        categories: Array.isArray(post.categories) ? post.categories : [NEWS_CATEGORY_ID],
                        category_number: NEWS_CATEGORY_ID,
                        source: "news",
                        acf: {
                            article_image: featuredImage,
                            article_link: `/blog/news/${post.slug}`,
                            article_content: post.content?.rendered || ''
                        }
                    };
                });
            }
        },
        {
            key: "blog",
            label: "Blog",
            fetch: async () => {
                const BLOG_CATEGORY_ID = 84;
                const resp = await axios.get(`https://new.whatson.agency/wp-json/wp/v2/posts?categories=${BLOG_CATEGORY_ID}&_embed&per_page=20&page=1`);
                const extractFirstImageSrc = (html) => {
                    if (!html) return '';
                    const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
                    return match ? match[1] : '';
                };
                return resp.data.map(post => {
                    let featuredImage = '';
                    if (post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0]) {
                        featuredImage = post._embedded['wp:featuredmedia'][0].source_url;
                    }
                    if (!featuredImage) {
                        featuredImage = extractFirstImageSrc(post.content?.rendered || '');
                    }
                    return {
                        id: post.id,
                        slug: post.slug,
                        title: post.title?.rendered || '',
                        content: post.content?.rendered || '',
                        excerpt: post.excerpt?.rendered || '',
                        date: post.date ? new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : undefined,
                        link: `/blog/blog/${post.slug}`,
                        author: (post._embedded && post._embedded.author && post._embedded.author[0] && post._embedded.author[0].name) ? post._embedded.author[0].name : undefined,
                        featured_image: featuredImage,
                        categories: Array.isArray(post.categories) ? post.categories : [BLOG_CATEGORY_ID],
                        category_number: BLOG_CATEGORY_ID,
                        source: "blog",
                        acf: {
                            article_image: featuredImage,
                            article_link: `/blog/blog/${post.slug}`,
                            article_content: post.content?.rendered || ''
                        }
                    };
                });
            }
        }
    ];

    const FuturisticSpinner = ({ size = 36 }) => {
        return (
            <span style={{ display: 'inline-block', width: size, height: size }}>
                <style>
                    {`
                        @keyframes ringRotate {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                        @keyframes pulseDot {
                            0% { transform: scale(0.9); opacity: 0.7; }
                            50% { transform: scale(1.2); opacity: 1; }
                            100% { transform: scale(0.9); opacity: 0.7; }
                        }
                    `}
                </style>
                <svg width={size} height={size} viewBox="0 0 52 52">
                    <defs>
                        <linearGradient id="grad-ring" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#7C3AED" />
                            <stop offset="50%" stopColor="#22D3EE" />
                            <stop offset="100%" stopColor="#F472B6" />
                        </linearGradient>
                        <filter id="glow">
                            <feGaussianBlur stdDeviation="2.5" result="coloredBlur"/>
                            <feMerge>
                                <feMergeNode in="coloredBlur"/>
                                <feMergeNode in="SourceGraphic"/>
                            </feMerge>
                        </filter>
                    </defs>
                    <g style={{ transformOrigin: '26px 26px', animation: 'ringRotate 1.2s linear infinite' }} filter="url(#glow)">
                        <circle cx="26" cy="26" r="20" fill="none" stroke="url(#grad-ring)" strokeWidth="4" strokeLinecap="round" strokeDasharray="70 130"/>
                    </g>
                    <circle cx="26" cy="8" r="3" fill="#22D3EE" style={{ animation: 'pulseDot 1.2s ease-in-out infinite' }}/>
                </svg>
            </span>
        );
    };

    const FuturisticMoreIcon = ({ size = 18 }) => {
        return (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                <style>
                    {`
                        @keyframes bounceDown {
                            0%, 100% { transform: translateY(0); opacity: 0.9; }
                            50% { transform: translateY(4px); opacity: 1; }
                        }
                    `}
                </style>
                <svg width={size} height={size} viewBox="0 0 24 24" style={{ animation: 'bounceDown 1.3s ease-in-out infinite' }}>
                    <defs>
                        <linearGradient id="grad-more" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#06b6d4"/>
                            <stop offset="100%" stopColor="#a78bfa"/>
                        </linearGradient>
                    </defs>
                    <path d="M6 8l6 6 6-6" stroke="url(#grad-more)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                </svg>
            </span>
        );
    };

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                setLoading(true);
                setError(null);
                const resultsSettled = await Promise.allSettled(API_SOURCES.map(s => s.fetch()));
                const combined = [];
                const seen = new Set();
                resultsSettled.forEach((res, idx) => {
                    if (res.status === "fulfilled" && Array.isArray(res.value)) {
                        res.value.forEach(item => {
                            if (!seen.has(item.id)) {
                                seen.add(item.id);
                                combined.push(item);
                            }
                        });
                    }
                });
                setAllItems(combined);
                setVisibleItems(combined.slice(0, dataVisibleCount));
                setCategories(API_SOURCES.map(s => [s.key, s.label]));
                setLoading(false);
            } catch (error) {
                console.error('Error fetching posts:', error);
                setError(error.message);
                setLoading(false);
            }
        };
        fetchPosts();
    }, []);

    useEffect(() => {
        if (allItems.length > 0) {
            setVisibleItems(allItems.slice(0, dataVisibleCount));
        }
    }, [dataVisibleCount, allItems]);

    const handleLoadMore = (e) => {
        e.preventDefault();
        let tempCount = dataVisibleCount + dataIncrement;
        
        if (dataVisibleCount >= allItems.length) {
            setNoMorePost(true);
        } else {
            setDataVisibleCount(tempCount);
            if (tempCount >= allItems.length) {
                setNoMorePost(true);
            }
        }
    };

    const handleChange = (category) => {
        setActiveFilter(category);
        let filteredItems;
        if (category === "all") {
            filteredItems = allItems.slice(0, dataVisibleCount);
        } else {
            filteredItems = allItems
                .filter(item => item.source === category)
                .slice(0, dataVisibleCount);
        }
        setVisibleItems(filteredItems);
    };

    // Loading state
    if (loading) {
        return (
            <div className="col-lg-12">
                <div className="text-center py-5">
                    <FuturisticSpinner size={36} />
                    <p className="mt-3">Loading...</p>
                </div>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="col-lg-12">
                <div className="alert alert-danger text-center">
                    <h4>Error Loading Posts</h4>
                    <p>{error}</p>
                    <button 
                        className="btn btn-primary" 
                        onClick={() => window.location.reload()}
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    // No posts found
    if (allItems.length === 0) {
        return (
            <div className="col-lg-12">
                <div className="text-center py-5">
                    <h4>No posts found in this category</h4>
                    <p>Check back later for new content!</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <ul className="rwt-portfolio-filter filter-button-default liststyle mb--20" style={{ marginTop: "24px" }}>
                        <li className="list-item">
                            <button
                                onClick={() => handleChange("all")}
                                className={activeFilter === "all" ? "current" : ""}
                            >
                                All
                            </button>
                        </li>
                        {categories.map(([categoryId, categoryName]) => (
                            <li className="list-item" key={categoryId}>
                                <button
                                    onClick={() => handleChange(categoryId)}
                                    className={activeFilter === categoryId ? "current" : ""}
                                >
                                    {categoryName}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="col-lg-12">
                <div className="row row--15">
                    {visibleItems.map((item) => (
                        <div key={item.id} className={column}>
                            <BlogListTwo StyleVar={StyleVarProp} data={item} />
                        </div>
                    ))}
                </div>
            </div>
            
            {allItems.length > dataVisibleCount && (
                <div className="col-lg-12">
                    <div className="rwt-load-more text-center mt--60">
                        <button
                            className="btn btn-default btn-icon"
                            onClick={handleLoadMore}
                            disabled={noMorePost}
                        >
                            {noMorePost ? (
                                "No More Posts"
                            ) : (
                                <span>
                                    View More Posts ({allItems.length - dataVisibleCount} remaining)
                                    <span className="icon">
                                        <FuturisticMoreIcon size={18} />
                                    </span>
                                </span>
                            )}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default BlogPropTwo;
